<script>
import AkDialogIcon from '@components/general/AkDialogIcon.vue';

export default {
  components: {AkDialogIcon},
  props: {
    label: {
      type: String,
      required: true,
    },
    class: {
      type: String,
      required: false,
    },
    little: {
      type: Boolean,
      required: false,
      default: true,
    },
    secondary: {
      type: Boolean,
      required: false,
      default: false,
    },
    danger: {
      type: Boolean,
      required: false,
      default: false,
    },
    success: {
      type: Boolean,
      required: false,
      default: false,
    },
    messagePopup: {
      type: String,
      required: false,
      default: undefined,
    },
    titlePopup: {
      type: String,
      required: false,
      default: undefined,
    },
    widthPopup: {
      type: String,
      default: '600px',
    },
    iconPopup: {
      type: String,
      required: false,
      default: 'bg-red-50 text-red ga-warning',
    },
    showIconPopup: {
      type: Boolean,
      required: false,
      default: true,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  emits: ['click'],
  computed: {
    buildClass() {
      if (this.class) return this.class;
      return {
        xs: this.little,
        'btn-primary': !this.secondary && !this.danger && !this.success,
        'btn-grey': this.secondary,
        'btn-red': this.danger,
        'btn-green': this.success,
        disabled: this.disabled,
      };
    },
    buildPopupMessage() {
      if (this.messagePopup) return this.messagePopup;
      return '';
    },
    buildPopupTitle() {
      if (this.titlePopup) return this.titlePopup;
      return '';
    },
  },
  methods: {
    init() {
      this.$refs.confirmDialog.init();
      this.$refs.confirmDialog.hide();
    },
    openConfirmDialog() {
      this.$refs.confirmDialog.show();
    },
    onConfirmYes() {
      this.$emit('click', this.init);
    },
  },
};
</script>

<template>
  <button :disabled="this.disabled" type="submit" @click="openConfirmDialog()" :class="buildClass">
    {{ this.label }}
  </button>

  <AkDialogIcon
    ref="confirmDialog"
    :icon="this.iconPopup"
    :message="buildPopupMessage"
    :title="buildPopupTitle"
    :cancel-label="$t('no')"
    :validate-label="$t('yes')"
    width="450px"
    @yes="onConfirmYes()">
  </AkDialogIcon>
</template>
